module.exports = __webpack_public_path__ + "static/img/Tom-Green.dcfb10a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Green.jpg
// module id = a8ix
// module chunks = 0